// sinsangAutofill.ts — hands the 叫貨 list to the Sinsang autofill extension.
//
// Each Sinsang tab opened from 叫貨 carries its 款's pending colour/size
// quantities (plus any option-label pairings already confirmed for that SKU) in
// the URL fragment. A fragment never leaves the browser, so Sinsang's server
// sees exactly the request it saw before; the extension reads it on the goods
// page and fills the quantity boxes. Without the extension the link behaves as
// it always did.

import { DemandGroup } from './demandGrouping';

/** sku → our variant name ("炭灰 / F") → Sinsang option label ("深灰色/Free"). */
export type SinsangOptionMap = Record<string, Record<string, string>>;

const SINSANG_HOST = /(^|\.)sinsangmarket\.kr$/i;

export function withSinsangOrder(
  link: string,
  group: Pick<DemandGroup, 'sku' | 'productName' | 'specs'>,
  optionMap?: SinsangOptionMap,
): string {
  let url: URL;
  try { url = new URL(link); } catch { return link; }
  // Leave non-Sinsang links, and any link that already uses its fragment, alone.
  if (!SINSANG_HOST.test(url.hostname) || url.hash) return link;
  const items = group.specs.filter(s => s.totalQty > 0).map(s => [s.variant, s.totalQty]);
  if (!group.sku || items.length === 0) return link;
  const payload = {
    v: 1,
    sku: group.sku,
    name: group.productName,
    items,
    map: optionMap?.[group.sku] || {},
  };
  url.hash = 'mt=' + encodeURIComponent(JSON.stringify(payload));
  return url.toString();
}
